/* global angular, TweenMax, Cubic, $ */
angular.module('ua5App')
    .directive('globalHeaderMobile', ['ModalService', 'BREAKPOINTS', '$timeout', function(ModalService, BREAKPOINTS, $timeout) {
        return {
            restrict: 'A',
            templateUrl: 'components/global-header-mobile/global-header-mobile.html',
            link: function($scope, element, attrs) {
                var $$element;
                var $$nav;
                var navAnimation;
                $$element = $(element);
                $$nav = $$element.find('.global-header-mobile__nav');
                // Toggle nav visibility
                $scope.toggleNav = function() {
                    // Abort mission if not viewing mobile
                    if ($(window).width() > BREAKPOINTS.MOBILE) {
                        return;
                    }
                    // Toggle open
                    $scope.open = !$scope.open;
                    if ($scope.open) {
                        navAnimation = TweenMax.to($$nav, 0.1, {
                            alpha: 1,
                            x: 0,
                            ease: Cubic.easeInOut
                        });
                    } else if (navAnimation) {
                        navAnimation.reverse();
                    }
                };
                $scope.apply = function() {
                    $scope.toggleNav();
                    ModalService.showModal({
                        templateUrl: 'components/apply/apply.html',
                        controller: 'ApplyCtrl',
                        controllerAs: 'ctrl'
                    });
                };
                $scope.search = function() {
                    ModalService.showModal({
                        templateUrl: 'components/search/search.html',
                        controller: 'SearchCtrl',
                        controllerAs: 'ctrl',
                        inputs: {
                            letter: null
                        }
                    });
                };
                $scope.$on('app:clicked', function(a, target) {
                    // Classes that will not close the nav menu if clicked
                    var safeClasses;
                    safeClasses = '.global-header-mobile__nav, .global-header-mobile__nav__item, .global-header-mobile__button--toggle';
                    // Was element with safe class clicked
                    if (
                        !$(target).is(safeClasses) &&
                        $scope.open
                    ) {
                        // Close nav if open
                        $scope.toggleNav();
                        $scope.$apply();
                    }
                });
                // Close nav on a state change
                $scope.$on('$stateChangeStart', function() {
                    if ($scope.open) {
                        // Close nav if open
                        $scope.toggleNav();
                    }
                });

                $timeout(function() {
                    var tsBodyScroll;
                    var contentOffset;
                    var lockPageBool;
                    $('.global-header-mobile__nav').bind('touchstart', function(e) {
                        tsBodyScroll = $('body').scrollTop();
                        contentOffset = $('div[ui-view]').eq(0).offset().top;
                        lockPageBool = $(window).height() < $(document).height();
                    });

                    $('.global-header-mobile__nav').bind('touchmove', function(e) {
                        if (lockPageBool) {
                            $('div[ui-view]').eq(0).css('position', 'fixed').css('top',  contentOffset - tsBodyScroll + 'px');
                        }
                    });

                    $('.global-header-mobile__nav').bind('touchend', function(e) {
                        if (lockPageBool) {
                            $('div[ui-view]').css('position', 'relative').css('top', 0);
                            $('body').scrollTop(tsBodyScroll);
                        }
                    });
                });
            }
        };
    }])
;
